// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

// Ping Base URL Configuration
// This should always point to the production server, even in staging
export const PING_BASE_URL = import.meta.env.VITE_PING_BASE_URL || 'https://cronwolf.de';

// Auth Token Key
export const AUTH_TOKEN_KEY = 'authToken';

// Project Storage Key
export const SELECTED_PROJECT_KEY = 'selectedProjectId';

// Downtime-flip retention (days). The backend is the source of truth: hc/api/tasks.py
// (pruneflips) and hc/api/models.py delete downtime flips older than this, for ALL
// plans (unlike ping_retention_days, which is plan-specific). Kept here as a single
// frontend constant so the privacy policy no longer hardcodes "93" in several places.
// Keep in sync with the backend value if it ever changes.
export const FLIP_RETENTION_DAYS = 93;

// Beta Program Configuration
export const BETA_CONFIG = {
  // Main beta program toggle (case-insensitive check)
  PROGRAM_ACTIVE: String(import.meta.env.VITE_BETA_PROGRAM_ACTIVE).toLowerCase() === 'true',

  // Allow new beta signups (case-insensitive check)
  SIGNUP_ACTIVE: String(import.meta.env.VITE_BETA_SIGNUP_ACTIVE).toLowerCase() === 'true',

  // Total beta spots available
  SPOTS_TOTAL: parseInt(import.meta.env.VITE_BETA_SPOTS_TOTAL || '50'),

  // Beta discount percentage
  DISCOUNT_PERCENT: parseInt(import.meta.env.VITE_BETA_DISCOUNT_PERCENT || '30'),

  // Enable beta feedback hub (case-insensitive check)
  FEEDBACK_HUB: String(import.meta.env.VITE_BETA_FEEDBACK_HUB).toLowerCase() === 'true',

  // Enable beta badges (case-insensitive check)
  BADGES: String(import.meta.env.VITE_BETA_BADGES).toLowerCase() === 'true',

  // Enable voting on feedback (case-insensitive check)
  VOTING: String(import.meta.env.VITE_BETA_VOTING).toLowerCase() === 'true',

  // Enable priority support for beta users (case-insensitive check)
  PRIORITY_SUPPORT: String(import.meta.env.VITE_BETA_PRIORITY_SUPPORT).toLowerCase() === 'true',
};
